export default {
  contact: 'Contact',
  credits: '© Mora. All rights reserved. :YEAR',
  designed_developed_by: 'Designed and developed by <strong>Beet</strong>.',
  privacy_policy: 'Privacy policy',
  your_email: 'Your email address',
}
